import { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useFormik } from 'formik';
import useLocalStorage from '../../extras/hooks/useLocalStorage';
import { AdminContext } from '../../context/AdminContext';
//import material
import { Button, Dialog, Switch, InputLabel, FormControl, FormControlLabel, TextField } from '@mui/material';
//import style
import { DialogTitle, DialogContent, DialogActions, ProductomodalContainer, GreenCheckbox, styles } from './productosComponents';
import { productCreateSchema, productUpdateSchema } from './validation';
//import adds
import sinImagen from '../../extras/image/sinImagen.png';
import GenericTextField from '../../components/generics/GenericTextField';
import ItemsTable from './molecules/ItemsTable';
import BarcodeSection from './molecules/BarcodeSection';
import GenericNativeSelect from '../../components/generics/GenericNativeSelect';
import ImageContainer from './molecules/ImageContainer';
import { GiClothespin } from 'react-icons/gi';
import ModalProductosRechazados from './ModalProductosRechazados';
import { SNACKBAR_SEVERITY } from '../../constants';
import { ProductContext } from '../../context/ProductContext';
import { baseURL } from '../../extras/Axios';
import { Autocomplete } from '@mui/material';
import { BsTrash } from 'react-icons/bs';
import { obtenerMarcasParaSelector, obtenerRubrosParaSelector } from '../../services/productServices';

function ModalProducto({ modal, closeModal, productSelection, userSelection }) {
  const classes = styles;
  // Context
  const { handleClickSnackbar } = useContext(AdminContext);
  const { agregarUnProducto, modificarUnProducto, agregarProductosEnMasa, modificarImagen, obtenerProductoPorId, getProductosConQuery } = useContext(ProductContext);

  // States
  const [isSendingBulk, setIsSendingBulk] = useState(false);
  const [isSendingProduct, setIsSendingProduct] = useState(false);
  const [rechazados, setRechazados] = useState([]);
  const [rechazadosModal, setRechazadosModal] = useState(false);
  const [agregarMuchosProductos, setAgregarMuchosProductos] = useState(false);
  const [publicar, setPublicar] = useState(productSelection ? productSelection.publicar : false);
  const [imageToUpload, setImageToUpload] = useState(null);
  const [preview, setPreview] = useState(sinImagen);
  const [marcaOption, setMarcaOption] = useState([]);
  const [selectedRows, setSelectedRows] = useState([])
  const [items, setItems] = useLocalStorage(userSelection.identificador, { lista: [] });
  const [selectorRubros, setSelectorRubros] = useState([]);


  function handleImageSelection(event) {
    const image = event.target.files[0];
    setPreview(URL.createObjectURL(image));
    setImageToUpload(image);
  }

  function agregarItemEnLista(item) {
    setItems(prev => {
      return {
        lista: [...prev.lista, { ...item, UserId: userSelection.identificador, publicar, id: prev.lista.length + 1 }],
      };
    });
  }

  async function handleFinalizar() {
    try {
      setIsSendingBulk(true);
      const aceptados = items.lista.map(it => {
        return { ...it, precio: parseFloat(it.precio) };
      });
      const exito = await agregarProductosEnMasa(aceptados, rechazados, userSelection.email)
      setItems({ lista: [] });
      if (exito) handleClickSnackbar('Productos creados con exito', SNACKBAR_SEVERITY.success);
      else handleClickSnackbar('Ocurrio un problema al crear los productos', SNACKBAR_SEVERITY.error);

      closeModal();
    } catch (error) {
      console.log('Error en handleFinalizar', error);
    }
  }

  const initialValues = productSelection
    ? { ...productSelection, ganancia: productSelection.quitarGanancia ? productSelection.precio : productSelection.ganancia, quitarGanancia: productSelection.quitarGanancia ?? false }
    : {
      descripcion: '',
      talle: '',
      palabrasClave: '',
      precio: '',
      ganancia: '',
      marca: '',
      quitarGanancia: false,
      temporada: 'PRIMAVERA/VERANO',
      condicionVenta: userSelection ? userSelection.preferenciaPago : '',
      estado: 'STOCK',
      rubro: 'Otros',
    };

  const preferedSchema = productSelection ? productUpdateSchema : productCreateSchema;

  const formik = useFormik({
    initialValues,
    validationSchema: preferedSchema,
    onSubmit: async producto => {
      try {
        setIsSendingProduct(true);

        // AGREGAR EN BULK
        if (agregarMuchosProductos) {
          // Agrega el producto a la lista y resetea el formulario sin cerrarlo para que se siga agregando
          agregarItemEnLista(producto);
          formik.resetForm();
          setPublicar(false);
          return;
        }
        // MODIFICAR PRODUCTO
        if (productSelection) {
          const estatus = await modificarUnProducto({ ...producto, publicar });
          if (estatus === 200) {
            handleClickSnackbar('Producto actualizado con exito', SNACKBAR_SEVERITY.success);
            await getProductosConQuery();
          }
          if (estatus === 404) handleClickSnackbar('No fue posible actualizar el producto', SNACKBAR_SEVERITY.error);
          if (imageToUpload) {
            const formData = new FormData();
            formData.append("_id", producto._id);
            formData.append("UserId", producto.UserId);
            formData.append("codigoProducto", producto.codigoProducto);
            formData.append("image", imageToUpload);
            const imagenSubida = await modificarImagen(formData);
            if (imagenSubida) handleClickSnackbar('imagen actualizada con exito', SNACKBAR_SEVERITY.success);
            else handleClickSnackbar('No fue posible actualizar la imagen', SNACKBAR_SEVERITY.error);
          }
          return closeModal();
        }

        // AGREGAR PRODUCTO
        const _id = await agregarUnProducto({ ...producto, UserId: userSelection.identificador, publicar });
        if (_id) {
          handleClickSnackbar('Producto creado con exito', SNACKBAR_SEVERITY.success);
          await getProductosConQuery();
        }
        else handleClickSnackbar('No fue posible crear el producto', SNACKBAR_SEVERITY.error);

        if (_id && imageToUpload) {
          const productoInsertado = await obtenerProductoPorId(_id);
          const formData = new FormData();
          formData.append("_id", productoInsertado._id);
          formData.append("UserId", productoInsertado.UserId);
          formData.append("codigoProducto", productoInsertado.codigoProducto);
          formData.append("image", imageToUpload);
          const imagenSubida = await modificarImagen(formData);
          if (imagenSubida) handleClickSnackbar('imagen agregada con exito', SNACKBAR_SEVERITY.success);
          else handleClickSnackbar('No fue posible agregar la imagen', SNACKBAR_SEVERITY.error);
        }
        setPreview(sinImagen);
        formik.resetForm();
        if (!agregarMuchosProductos) {
          closeModal()
        }
      } catch (error) {
        console.log('Error en onSubmit', error);
        handleClickSnackbar('Ocurrió un error al procesar el producto', SNACKBAR_SEVERITY.error);
      } finally {
        setIsSendingProduct(false);
      }
    },
    enableReinitialize: true,
  });

  const handleCheckChange = () => {
    setAgregarMuchosProductos(prev => !prev);
  };
  const handleSwitchChange = () => {
    setPublicar(!publicar);
  };

  const handleClose = () => {
    setItems({ lista: [] });
    closeModal();
  };

  useEffect(() => {
    if (!productSelection) return;
    if (productSelection.imagePath && productSelection.imagePath !== '') {
      const url = `${baseURL}images/`;
      const preview = `${url}${productSelection.imagePath}`;
      setPreview(preview);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productSelection]);

  useEffect(() => {
    obtenerMarcasParaSelector()
      .then(
        marcas =>
          setMarcaOption(marcas))
      .catch(err => console.log(err));
  }, []);

  useEffect(() => {
    obtenerRubrosParaSelector()
      .then(
        rubros =>
          setSelectorRubros(Object.keys(rubros)))
      .catch(err => console.log(err));
  }, []);

  return (
    <div>
      <Dialog fullScreen={(!productSelection?.id && agregarMuchosProductos) ? true : false} onClose={handleClose} aria-labelledby='customized-dialog-title' open={modal} maxWidth='lg'>
        <form onSubmit={formik.handleSubmit} className={classes.form}>
          <DialogTitle id='customized-dialog-title' onClose={handleClose}>
            <ProductomodalContainer>
              {userSelection ? (!productSelection ? `Agregar  producto a ${userSelection.nombreCompleto}` : `Modificar producto de ${userSelection.nombreCompleto}`) : null}
              {!agregarMuchosProductos ?
                <FormControlLabel
                  control={
                    <Switch
                      checked={formik.values.quitarGanancia}
                      onChange={formik.handleChange}
                      id="quitarGanancia"
                      name="quitarGanancia"
                      color='secondary'
                      inputProps={{ 'aria-label': 'primary checkbox' }} />
                  }
                  label='Quitar Ganancias' />
                : null}

              {agregarMuchosProductos ? (
                <Button variant='outlined' disabled={isSendingBulk} color='primary' onClick={handleFinalizar}>
                  Finalizar
                </Button>
              ) : null}
              {agregarMuchosProductos ? (
                <Button variant='outlined' color='primary' onClick={handleClose}>
                  Cancelar
                </Button>
              ) : null}
            </ProductomodalContainer>
          </DialogTitle>
          <DialogContent dividers>
            <ModalProductosRechazados
              modal={rechazadosModal}
              rechazados={rechazados}
              setRechazados={setRechazados}
              toggleModal={() => {
                setRechazadosModal(prev => !prev);
              }}
            />
            {!productSelection?._id ? <FormControlLabel control={<GreenCheckbox checked={agregarMuchosProductos} onChange={handleCheckChange} name='checkedG' />} label='Cargar multiples productos' /> : null}

            <GenericTextField campo='descripcion' formik={formik} fullWidth={!productSelection?.id ? true : false} style={{ width: 700 }} />
            <ProductomodalContainer>
              <GenericTextField campo='palabrasClave' formik={formik} fullWidth />
              <GenericTextField campo='talle' formik={formik} />
              <Autocomplete
                variant="standard"
                freeSolo
                options={marcaOption}
                id='marca'
                type='text'
                name='marca'
                label='Marca'
                inputValue={formik.values.marca}
                renderInput={params => <TextField  {...params} label='Marca' variant='standard' />}
                onInputChange={(event, value) => {
                  if (value) formik.setFieldValue('marca', value)
                  else formik.setFieldValue('marca', "")
                }}
                onChange={(event, value) => {
                  if (value) formik.setFieldValue('marca', value)
                  else formik.setFieldValue('marca', "")
                }}
                error={formik.touched.marca && Boolean(formik.errors.marca)}
              />
              <GenericTextField campo='precio' formik={formik} />
              <GenericTextField campo='ganancia' formik={formik} disabled />
              <FormControl variant="standard" className={classes.formControl}>
                <InputLabel htmlFor='condicionVenta'>Condiciones de Venta</InputLabel>
                <GenericNativeSelect formik={formik} field='condicionVenta'>
                  <option aria-label='Ninguna' value='NINGUNA' />
                  <option value={'CREDITO'}>CREDITO</option>
                  <option value={'EFECTIVO'}>EFECTIVO</option>
                </GenericNativeSelect>
              </FormControl>
              {/*  --------------------RUBROS-------------------- */}
              <FormControl variant="standard" className={classes.formControl}>
                <Autocomplete
                  variant="standard"
                  freeSolo
                  options={selectorRubros}
                  id='rubro'
                  name='rubro'
                  value={formik.values.rubro}
                  inputValue={formik.values.rubro}
                  renderInput={params => <TextField  {...params} label='Elija un rubro' variant='standard' error={formik.touched.rubro && Boolean(formik.errors.rubro)} helperText={formik.touched.rubro && formik.errors.rubro} />}
                  onInputChange={(event, value) => {
                    if (value) formik.setFieldValue('rubro', value)
                    else formik.setFieldValue('rubro', "")
                  }}
                  onChange={(event, value) => {
                    if (value) formik.setFieldValue('rubro', value)
                    else formik.setFieldValue('rubro', "")
                  }}
                />
              </FormControl>
              <FormControl variant="standard" className={classes.formControl}>
                <InputLabel htmlFor='estado'>Estado</InputLabel>
                <GenericNativeSelect formik={formik} field='estado'>
                  <option value={'STOCK'}>STOCK</option>
                  <option value={'VENDIDO'}>VENDIDO</option>
                  <option value={'RESERVADO'}>RESERVADO</option>
                  <option value={'OTRO'}>OTRO</option>
                </GenericNativeSelect>
              </FormControl>
              <FormControl variant="standard" className={classes.formControl}>
                <InputLabel htmlFor='temporada'>temporada</InputLabel>
                <GenericNativeSelect formik={formik} field='temporada'>
                  <option defaultValue value={'PRIMAVERA/VERANO'}>PRIMAVERA/VERANO</option>
                  <option value={'OTOÑO/INVIERNO'}>OTOÑO/INVIERNO</option>
                  <option value={'TODAS'}>TODAS</option>
                </GenericNativeSelect>
              </FormControl>
            </ProductomodalContainer>
            <ProductomodalContainer>
              {!agregarMuchosProductos ? <ImageContainer preview={preview} handleImageSelection={handleImageSelection} /> : null}
              {productSelection && userSelection ? <BarcodeSection codigoProducto={formik.values.codigoProducto} UserId={formik.values.UserId} /> : null}
            </ProductomodalContainer>
            {agregarMuchosProductos ? <ItemsTable selectedRows={selectedRows} setSelectedRows={setSelectedRows} extraColumns={[
              {
                name: 'Borrar',
                button: true,
                selector: row => <BsTrash
                  onClick={() => {
                    if (window.confirm(`Seguro que desea eliminar ${row.descripcion} `)) {
                      // Borrar de la lista
                      setItems(prev => {
                        return {
                          lista: prev.lista.filter(item => item.id !== row.id)
                        }
                      })
                    }
                  }
                  }
                  size='1rem'
                  title='Borrar'
                  cursor='pointer'
                />
              }]} omitDate={true} omitCodigo={true} items={items.lista} /> : null}
          </DialogContent>
          <DialogActions>
            {productSelection ? <FormControlLabel control={<Switch checked={publicar} onChange={handleSwitchChange} color='primary' name='publicar' inputProps={{ 'aria-label': 'primary checkbox' }} />} label='Publicar' /> : null}

            {agregarMuchosProductos ? (
              <Button variant='outlined' onClick={() => setRechazadosModal(prev => !prev)} color='secondary' endIcon={<GiClothespin />}>
                Agregar Prendas Rechazadas
              </Button>
            ) : null}

            <Button color='primary' variant='contained' type='button' onClick={formik.submitForm} disabled={isSendingProduct}>
              {productSelection ? 'Modificar' : 'Agregar'}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}

ModalProducto.propTypes = {
  modal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  productSelection: PropTypes.object,
  userSelection: PropTypes.object,
};

export default ModalProducto;
